<div class="date-row">
  <div>{{ dataChange(news.addedAt) }}</div>
  <button icon-button (click)="dismissNews()">
    <gl-icon [name]="'close'" class="icon-close"></gl-icon>
  </button>
</div>
<div class="news-row">
  @if (news.state === 'new') {
    <div class="active"></div>
  }
  <div [innerHTML]="news.content"></div>
</div>
<div class="buttons-row">
  @if (news.articleUrl) {
    <button text-button (click)="goToUrl(news.articleUrl)">{{ 'more' | translate}}</button>
  }
</div>
